/* eslint-disable import/prefer-default-export */
import React from "react";
import CompanyContext from "src/Pages/Company/CompanyContext";
import __ from "src/utils/Translations";
import {
  banksBanksPermissionRead,
  companyCompanyPermissionRead,
  companyFundingPermissionRead,
  companyMultisportCardWaitingRoom,
  employeeAhrRolePermissionRead,
  employeeEmployeeGroupPermissionRead,
  employeeEmployeeGroupPermissionWrite,
  employeeEmployeePermissionRead,
  employeeEmployeePermissionWrite,
  employeeGroupProductConfigPermissionRead,
  employeeOrganizationUnitPermissionRead,
  employeeRentableGroupPermissionRead,
  companyTokenPermissionRead,
  subscriptionBenefitPermissionRead,
  subscriptionBenefitPermissionWrite,
  notificationAppMessagePermissionRead,
  configurationConfigurationPermissionRead,
  companyAccessToSportsCards,
  employeeRentableGroupSelectionWindowPermissionRead,
  companyReportAccessPasswordRead,
  companyMyBenefitActiveRead,
  // companyPrepaidCardWrite,
  proposalsModulePermissionRead,
  totalRewardSettings,
  totalRewardPerkUsersRead,
  totalRewardPerkUsersImportExport,
  totalRewardPerksRead,
  totalRewardPerkCategoriesRead,
  organizationStructureModuleRead,
  organizationStructureEmployeeDataExport,
  organizationStructureEmployeeDataImport,
  absencesModuleRead,
  companySubscriptionsWaitingRoom,
  wallModuleWrite,
  organizationStructureEmployeeDataRead,
  organizationStructureAreaRead,
  knowledgeBaseModuleWrite,
  organizationStructureAreaImport,
  organizationStructureAreaExport,
  organizationStructureSyncErrors,
  organizationStructureLocalizationImportHistoryRead,
  organizationStructurePositionImportHistoryRead,
} from "src/utils/RoleBasedSecurity/permissions";
import FEATURE_FLAGS from "src/utils/constants/featureFlags";

export const CompanySubMenu = {
  code: "company",
  getTitle: (location) => (
    <div className="text-wrap">
      {__("Zarządzanie firmą")}
      <CompanyContext.Consumer>
        {({ data }) => (data && data.fullName ? `: ${data.fullName}` : "")}
      </CompanyContext.Consumer>
    </div>
  ),
  getId: (location) => location.split("/")[3],
  parent_id: "company_list",
  getConfig: (location, companyId = null, excludeIds = []) => {
    if (!companyId) {
      // eslint-disable-next-line no-param-reassign
      companyId = CompanySubMenu.getId(location);
    }
    const prefix = `/company/edit/${companyId}`;
    return [
      {
        label: "Edycja firmy",
        to: `${prefix}/data`,
        id: "companyEdit",
        permission: companyCompanyPermissionRead,
        icon: "pe-7s-config",
      },
      {
        label: "Zarządzanie pracownikami",
        to: `${prefix}/employee-management`,
        id: "employeeManagement",
        icon: "pe-7s-user",
        content: [
          {
            label: "Pracownicy",
            to: `${prefix}/employee-management/employees`,
            id: "companyEmployee",
            aclKey: employeeEmployeePermissionRead,
            tileIcon: "pe-7s-user",
          },
          {
            label: "Administratorzy",
            to: `${prefix}/employee-management/ahr`,
            id: "companyAhrs",
            aclKey: employeeAhrRolePermissionRead,
            tileIcon: "pe-7s-tools",
          },
          {
            label: "Grupy pracownicze",
            to: `${prefix}/employee-management/employee-groups`,
            id: "employeeGroups",
            aclKey: employeeEmployeeGroupPermissionRead,
            tileIcon: "pe-7s-users",
          },
          {
            label: "Grupy dochodowości",
            to: `${prefix}/employee-management/rentable-groups`,
            id: "rentableGroups",
            aclKey: employeeRentableGroupPermissionRead,
            tileIcon: "pe-7s-users",
          },
          {
            label: "Zarządzanie oknami grup dochodowości",
            to: `${prefix}/employee-management/rentable-group-selection-windows`,
            id: "rentableGroupSelectionWindow",
            aclKey: employeeRentableGroupSelectionWindowPermissionRead,
            tileIcon: "pe-7s-photo-gallery",
          },
          {
            label: "Jednostki organizacyjne",
            to: `${prefix}/employee-management/organization-units`,
            id: "organization_units",
            aclKey: employeeOrganizationUnitPermissionRead,
            tileIcon: "pe-7s-add-user",
          },
          {
            label: "Działy w firmie",
            to: `${prefix}/employee-management/departments`,
            id: "company_departments",
            aclKey: employeeEmployeePermissionRead,
            tileIcon: "pe-7s-users",
          },
          {
            label: "Export i import danych pracowników",
            id: "import_export_data",
            to: `${prefix}/employee-management/import-export-data`,
            featureFlag:
              FEATURE_FLAGS.ORGANIZATION_STRUCTURE_IMPORT_EXPORT_EMPLOYEES_TAB,
            functionality: "ENABLE_ORGANIZATION_STRUCTURE",
            tileIcon: "pe-7s-download",
            aclKey: [
              organizationStructureEmployeeDataImport,
              organizationStructureEmployeeDataExport,
            ],
            isStructureRequired: true,
          },
          {
            id: "sync-errors",
            tileIcon: "pe-7s-user",
            label: "Błędy synchronizacji",
            to: `${prefix}/employee-management/sync-errors`,
            featureFlag: FEATURE_FLAGS.ORGANIZATION_STRUCTURE_SYNC_ERRORS,
            functionality: "ENABLE_ORGANIZATION_STRUCTURE",
            aclKey: organizationStructureSyncErrors,
          },
        ],
      },
      {
        label: "Abonamenty",
        to: `${prefix}/subscriptions`,
        id: "subscriptionsConfig",
        icon: "pe-7s-diamond",
        functionality: "ENABLE_PERIOD_SUBSCRIPTION_AND_IDEAL_CAFETERIA",
        content: [
          {
            label: "Świadczenia abonamentowe",
            to: `${prefix}/subscriptions/benefits`,
            id: "subscriptionsBenefits",
            aclKey: subscriptionBenefitPermissionRead,
            tileIcon: "pe-7s-diamond",
            isAnchor: true,
          },
          {
            label: "Konfiguracja abonamentów",
            to: `${prefix}/subscriptions/config`,
            id: "subscriptionsBenefitsConfig",
            aclKey: subscriptionBenefitPermissionRead,
            tileIcon: "pe-7s-diamond",
          },
        ],
      },
      {
        label: "Abonamenty pozostałe (UMS)",
        to: `${prefix}/ums-subscriptions`,
        id: "umsSubscriptionsConfig",
        icon: "pe-7s-diamond",
        functionality: "ENABLE_OTHER_PERIOD_SUBSCRIPTION_UMS",
        content: [
          {
            label: "Świadczenia abonamentowe",
            to: `${prefix}/ums-subscriptions/benefits`,
            id: "subscriptionsUmsBenefits",
            aclKey: subscriptionBenefitPermissionRead,
            tileIcon: "pe-7s-diamond",
            isAnchor: true,
          },
          {
            label: "Konfiguracja abonamentów",
            to: `${prefix}/ums-subscriptions/config`,
            id: "subscriptionsUmsBenefitsConfig",
            aclKey: subscriptionBenefitPermissionRead,
            tileIcon: "pe-7s-diamond",
          },
        ],
      },
      {
        label: "Lista świadczeń cyklicznych",
        to: `${prefix}/subscription-benefits`,
        id: "subscriptionBenefits",
        aclKey: subscriptionBenefitPermissionRead,
        icon: "pe-7s-diamond",
      },
      {
        label: "Zarządzanie produktami",
        to: `${prefix}/products`,
        id: "companyProducts",
        icon: "pe-7s-gift",
        content: [
          // Probably to delete with components
          // {
          //   label: 'Produkty zgrupowane',
          //   to: `${prefix}/products/clusters-benefits`,
          //   id: 'benefits_grouped',
          //   aclKey: 'benefits_grouped',
          //   tileIcon: 'pe-7s-plugin',
          // },
          {
            label: "Produkty w firmie",
            to: `${prefix}/products/egp`,
            id: "employeeGroupProducts",
            aclKey: employeeGroupProductConfigPermissionRead,
            tileIcon: "pe-7s-diamond",
          },
          {
            label: "Wyszukiwarka produktów",
            to: `${prefix}/products/search`,
            id: "employeeProductsSearch",
            aclKey: employeeGroupProductConfigPermissionRead,
            tileIcon: "pe-7s-diamond",
          },
        ],
      },
      {
        label: "Benefity oczekujące",
        to: `${prefix}/pending-benefits`,
        id: "pendingBenefits",
        icon: "pe-7s-next",
        functionalities: [
          "ENABLE_MSI_CARDS",
          "ENABLE_PERIOD_SUBSCRIPTION_AND_IDEAL_CAFETERIA",
          "ENABLE_OTHER_PERIOD_SUBSCRIPTION_UMS",
        ],
        aclKey: [
          companySubscriptionsWaitingRoom,
          companyMultisportCardWaitingRoom,
        ],
      },
      {
        label: "Banki punktów",
        to: `${prefix}/banks`,
        id: "companyBanks",
        icon: "pe-7s-piggy",
        content: [
          {
            label: "Konfiguracja banków punktów",
            to: `${prefix}/banks/config`,
            id: "companyBanksConfig",
            aclKey: banksBanksPermissionRead,
            tileIcon: "pe-7s-config",
          },
          {
            label: "Zarządzanie bankami punktów",
            to: `${prefix}/banks/management`,
            id: "companyBanksManagement",
            aclKey: banksBanksPermissionRead,
            tileIcon: "pe-7s-magic-wand",
          },
        ],
      },
      // Module probably to delete
      // {
      //   label: 'CMS',
      //   to: `${prefix}/cms/management`,
      //   id: 'cms',
      //   aclKey: cmsDocumentPermissionRead,
      //   icon: 'pe-7s-plugin',
      // },
      {
        label: "Moduł wynagrodzeń",
        to: `${prefix}/payroll-module`,
        id: "payrollModule",
        icon: "pe-7s-wallet",
        functionality: "ENABLE_PAYROLL_MODULE",
        featureFlag: FEATURE_FLAGS.PAYROLL_MODULE,
        content: [
          {
            label: "Konfiguracja modułu wynagrodzeń",
            id: "payrollModuleConfig",
            to: `${prefix}/payroll-module/config`,
            tileIcon: "pe-7s-config",
          },
        ],
      },
      {
        label: "Zarządzanie tokenami",
        to: `${prefix}/token_management`,
        id: "tokenManagement",
        aclKey: companyTokenPermissionRead,
        icon: "pe-7s-lock",
      },
      {
        label: "Parametry konfiguracyjne",
        to: `${prefix}/configuration`,
        id: "configuration",
        aclKey: configurationConfigurationPermissionRead,
        icon: "pe-7s-config",
        isAnchor: true,
      },
      {
        icon: "pe-7s-comment",
        label: "Powiadomienia",
        id: "notification",
        to: `${prefix}/notification`,
        content: [
          {
            label: "Wiadomości wewnątrzsystemowe",
            to: `${prefix}/notification/app-messages`,
            id: "appMessages",
            aclKey: notificationAppMessagePermissionRead,
            tileIcon: "pe-7s-chat",
          },
        ],
      },
      {
        label: "Historia importów",
        icon: "pe-7s-download",
        to: `${prefix}/imports-history`,
        isAnchor: true,
        aclKey: [
          organizationStructureAreaRead,
          organizationStructureEmployeeDataRead,
          organizationStructurePositionImportHistoryRead,
          organizationStructureLocalizationImportHistoryRead,
        ],
        id: "importsHistory",
        tail: true,
      },
      {
        label: "Importy",
        to: `${prefix}/imports`,
        id: "imports",
        icon: "pe-7s-download",
        content: [
          {
            label: "Import pracowników",
            to: `${prefix}/imports/employee`,
            id: "importsEmployee",
            aclKey: employeeEmployeePermissionWrite,
            tileIcon: "pe-7s-add-user",
          },
          {
            label: "Import kart sportowych",
            to: `${prefix}/imports/sport-cards`,
            id: "importsSportCards",
            aclKey: subscriptionBenefitPermissionWrite,
            tileIcon: "pe-7s-ball",
          },
          {
            label: "Import rezygnacji z kart sportowych",
            to: `${prefix}/imports/resignation-sport-cards`,
            id: "importsSportCardsResignation",
            aclKey: subscriptionBenefitPermissionWrite,
            tileIcon: "pe-7s-config",
          },
          {
            label: "Import świadczeń abonamentowych",
            to: `${prefix}/imports/subscriptions`,
            id: "importsSubscriptions",
            aclKey: subscriptionBenefitPermissionWrite,
            tileIcon: "pe-7s-diamond",
          },
          {
            label: "Import anulacji świadczeń abonamentowych",
            to: `${prefix}/imports/resignation-subscriptions`,
            id: "importsSubscriptionsResignation",
            aclKey: subscriptionBenefitPermissionWrite,
            tileIcon: "pe-7s-config",
          },
          {
            label: "Import otwarcia indywidualnych okien wyboru abonamentów",
            to: `${prefix}/imports/individual-window-subscriptions`,
            id: "importsSubscriptionsIndividualWindow",
            aclKey: subscriptionBenefitPermissionWrite,
            tileIcon: "pe-7s-config",
          },
          {
            label: "Import formularzy świadczeń abonamentowych",
            to: `${prefix}/imports/forms-subscriptions`,
            id: "importsSubscriptionsForms",
            aclKey: subscriptionBenefitPermissionWrite,
            tileIcon: "pe-7s-note2",
          },
          {
            label: "Import zmian numerów FK i maili",
            to: `${prefix}/imports/email-fk-changes`,
            id: "importsEmailFkChanges",
            aclKey: employeeEmployeePermissionWrite,
            tileIcon: "pe-7s-id",
          },
          {
            label: "Import dezaktywacji kont pracowników",
            to: `${prefix}/imports/deactivate-employee`,
            id: "importsDeactivateEmployee",
            aclKey: employeeEmployeePermissionWrite,
            tileIcon: "pe-7s-delete-user",
          },
          {
            label: "Import grup pracowniczych i grup dochodowości",
            to: `${prefix}/imports/groups`,
            id: "importsGroups",
            aclKey: employeeEmployeeGroupPermissionWrite,
            tileIcon: "pe-7s-users",
          },
          {
            label: "Import zmian cech pracowników",
            to: `${prefix}/imports/change-employee-attributes`,
            id: "importsEmployeeAttributesChanges",
            aclKey: employeeEmployeePermissionWrite,
            tileIcon: "pe-7s-magic-wand",
          },
          {
            label: "Import dofinansowań",
            to: `${prefix}/imports/fundings`,
            id: "importsFundings",
            aclKey: companyFundingPermissionRead,
            tileIcon: "pe-7s-cash",
          },
          {
            label: "Import zmiany daty startu kont",
            to: `${prefix}/imports/change-account-start-date`,
            id: "importsAccountStartDateChanges",
            aclKey: employeeEmployeePermissionWrite,
            tileIcon: "pe-7s-magic-wand",
          },
          {
            label: "Import zmiany loginów",
            to: `${prefix}/imports/change-login`,
            id: "importsLoginChanges",
            aclKey: employeeEmployeePermissionWrite,
            tileIcon: "pe-7s-magic-wand",
          },
        ],
      },
      {
        icon: "pe-7s-unlock",
        label: "Dostępy",
        id: "access",
        aclKey: companyReportAccessPasswordRead,
        to: `${prefix}/access`,
      },
      {
        label: "Konfigurator Kart Sportowych",
        id: "configuration_sports_cards",
        href: `/ui/msi-contract-configurator/company/${companyId}/company-contract/list`,
        aclKey: companyAccessToSportsCards,
        icon: "pe-7s-ball",
      },
      {
        icon: "pe-7s-user",
        label: "Dashboard",
        to: `${prefix}/dashboard`,
        isAnchor: false,
        functionality: "ENABLE_DASHBOARD",
        featureFlag: FEATURE_FLAGS.DASHBOARD_VISIBILITY,
        tail: true,
        id: "dashboard",
        content: [
          {
            label: "Widżety",
            to: `${prefix}/dashboard/widgets`,
            id: "dashboardWidget",
            tileIcon: "pe-7s-user",
            featureFlag: FEATURE_FLAGS.DASHBOARD_WIDGETS,
          },
          {
            label: "Konfiguracja menu",
            to: `${prefix}/dashboard/menu-configuration`,
            id: "dashboardMenuConfiguration",
            tileIcon: "pe-7s-user",
            featureFlag: FEATURE_FLAGS.DASHBOARD_MENU_CONFIGURATION,
          },
          {
            label: "Profil użytkownika",
            to: `${prefix}/dashboard/employee-profile`,
            id: "dashboardEmployeeProfile",
            tileIcon: "pe-7s-user",
            featureFlag: FEATURE_FLAGS.DASHBOARD_EMPLOYEE_PROFILE,
          },
          {
            label: "Podgląd widoczności modułów",
            to: `${prefix}/dashboard/modules-visibility-configuration`,
            id: "dashboardModulesVisibilityConfiguration",
            tileIcon: "pe-7s-user",
            featureFlag:
              FEATURE_FLAGS.DASHBOARD_MODULES_VISIBILITY_CONFIGURATION,
          },
        ],
      },
      {
        icon: "pe-7s-smile",
        label: "MyBenefit Active",
        id: "myb_active",
        aclKey: companyMyBenefitActiveRead,
        functionality: "ENABLE_MYBENEFIT_ACTIVE",
        href: "{MyBenefitActiveUrl}",
      },
      {
        icon: "pe-7s-cash",
        label: "Karty Przedpłacone",
        id: "prepaidCards",
        to: `${prefix}/prepaid-cards`,
        // aclKey: companyPrepaidCardWrite,
        functionality: "ENABLE_PREPAID_CARDS",
        content: [
          {
            icon: "pe-7s-cash",
            label: "Edycja kart przedpłaconych",
            id: "edit_KPP",
            aclKey: companyCompanyPermissionRead,
            to: `${prefix}/prepaid-cards/data`,
            tileIcon: "pe-7s-cash",
          },
          {
            icon: "pe-7s-unlock",
            label: "Export kart przedpłaconych",
            id: "export_KPP",
            aclKey: companyCompanyPermissionRead,
            to: `${prefix}/prepaid-cards/export`,
            tileIcon: "pe-7s-add-user",
          },
          {
            icon: "pe-7s-unlock",
            label: "Import kart przedpłaconych",
            id: "import_KPP",
            aclKey: companyCompanyPermissionRead,
            to: `${prefix}/prepaid-cards/import`,
            tileIcon: "pe-7s-add-user",
          },
        ],
      },
      {
        icon: "pe-7s-smile",
        label: "Imprezy Firmowe",
        id: "companyEvents",
        to: `${prefix}/company-events`,
        tileIcon: "pe-7s-smile",
        functionality: "ENABLE_COMPANY_EVENTS",
      },
      {
        icon: "pe-7s-drawer",
        label: "Wnioski i dofinansowania",
        id: "proposals",
        to: `${prefix}/proposals`,
        functionality: "ENABLE_PROPOSALS",
        aclKey: proposalsModulePermissionRead,
      },
      {
        icon: "pe-7s-medal",
        label: "Total Reward Statement",
        id: "totalRewardStatement",
        to: `${prefix}/total-reward`,
        functionality: "ENABLE_TOTAL_REWARD_STATEMENT",
        content: [
          {
            icon: "pe-7s-note2",
            label: "Przydzielone Benefity",
            id: "view_totalRewardPerkUsers",
            to: `${prefix}/total-reward/perk-users`,
            aclKey: totalRewardPerkUsersRead,
            tileIcon: "pe-7s-note2",
          },
          {
            icon: "pe-7s-repeat",
            label: "Import/export benefitów",
            id: "view_totalRewardImportExportPerkUsers",
            to: `${prefix}/total-reward/perkusers-import`,
            aclKey: totalRewardPerkUsersImportExport,
            tileIcon: "pe-7s-repeat",
          },
          {
            icon: "pe-7s-tools",
            label: "Zarządzanie benefitami",
            id: "view_totalRewardPerks",
            to: `${prefix}/total-reward/perks`,
            aclKey: totalRewardPerksRead,
            tileIcon: "pe-7s-tools",
          },
          {
            icon: "pe-7s-drawer",
            label: "Zarządzanie kategoriami",
            id: "view_totalRewardCategories",
            to: `${prefix}/total-reward/categories`,
            aclKey: totalRewardPerkCategoriesRead,
            tileIcon: "pe-7s-drawer",
          },
          {
            icon: "pe-7s-settings",
            label: "Ustawienia modułu",
            id: "view_totalRewardSettings",
            to: `${prefix}/total-reward/settings`,
            aclKey: totalRewardSettings,
            tileIcon: "pe-7s-settings",
          },
        ],
      },
      {
        icon: "pe-7s-plane",
        label: "Nieobecności",
        id: "absences",
        to: `${prefix}/absences`,
        aclKey: absencesModuleRead,
        functionality: "ENABLE_ABSENCE_MODULE",
        featureFlag: FEATURE_FLAGS.ABSENCES,
        dataTestId: "absences-menu-item",
      },
      {
        label: "Struktura Organizacji",
        to: `${prefix}/organization-structure`,
        id: "organization_structure",
        icon: "pe-7s-graph1",
        functionality: "ENABLE_ORGANIZATION_STRUCTURE",
        featureFlag: FEATURE_FLAGS.ORGANIZATION_STRUCTURE,
        aclKey: organizationStructureModuleRead,
        content: [
          {
            label: "Konfiguracja Struktury",
            id: "structure_configuration",
            to: `${prefix}/organization-structure/configure-structure`,
            tileIcon: "pe-7s-edit",
            aclKey: organizationStructureModuleRead,
          },
          {
            label: "Lokalizacje",
            id: "localizations",
            to: `${prefix}/organization-structure/localizations`,
            tileIcon: "pe-7s-config",
            featureFlag: FEATURE_FLAGS.ORGANIZATION_STRUCTURE_LOCALIZATIONS,
            isStructureRequired: true,
          },
          {
            label: "Import/Eksport lokalizacji",
            id: "localizations",
            to: `${prefix}/organization-structure/localizations/import-export-localizations`,
            tileIcon: "pe-7s-config",
            featureFlag:
              FEATURE_FLAGS.ORGANIZATION_STRUCTURE_LOCALIZATIONS_IMPORT_EXPORT_TAB,
            notDisplay: true,
          },
          {
            label: "Stanowiska",
            id: "positions",
            to: `${prefix}/organization-structure/positions`,
            tileIcon: "pe-7s-config",
            featureFlag: FEATURE_FLAGS.ORGANIZATION_STRUCTURE_POSITIONS,
            isStructureRequired: true,
          },
          {
            label: "Import/export danych obszaru",
            id: "import-export-area-data",
            to: `${prefix}/organization-structure/import-export-area-data`,
            tileIcon: "pe-7s-config",
            isStructureRequired: true,
            notDisplay: true,
            featureFlag:
              FEATURE_FLAGS.ORGANIZATION_STRUCTURE_IMPORT_EXPORT_EMPLOYEES_TAB,
            functionality: "ENABLE_ORGANIZATION_STRUCTURE",
            aclKey: [
              organizationStructureAreaImport,
              organizationStructureAreaExport,
            ],
          },
          {
            label: "Ustawienia modułu",
            id: "module_settings",
            to: `${prefix}/organization-structure/module-settings`,
            tileIcon: "pe-7s-config",
            aclKey: organizationStructureModuleRead,
          },
        ],
      },
      {
        label: "Aktualności",
        to: `${prefix}/wall`,
        id: "wall",
        icon: "pe-7s-news-paper",
        functionality: "ENABLE_WALL",
        featureFlag: FEATURE_FLAGS.WALL_MODULE_SETTINGS,
        aclKey: wallModuleWrite,
      },
      {
        label: "Baza wiedzy",
        to: `${prefix}/knowledge-base`,
        id: "knowledge-base",
        icon: "pe-7s-notebook",
        functionality: "ENABLE_KNOWLEDGE_BASE",
        featureFlag: FEATURE_FLAGS.KNOWLEDGE_BASE_SETTINGS,
        aclKey: knowledgeBaseModuleWrite,
      },
    ].filter((el) => !excludeIds.includes(el.id));
  },
};
